module.exports = __webpack_public_path__ + "static/media/photo-title.8b46fab5.svg";